import { render, staticRenderFns } from "./CandidateWrapper.vue?vue&type=template&id=cb5fdc72&scoped=true"
import script from "./CandidateWrapper.vue?vue&type=script&lang=ts"
export * from "./CandidateWrapper.vue?vue&type=script&lang=ts"
import style0 from "./CandidateWrapper.vue?vue&type=style&index=0&id=cb5fdc72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5fdc72",
  null
  
)

export default component.exports